const map = {
    "sale": "for-sale",
    "rent": "for-rent",
    "projects serp": "projects",
    "promotion": "projects"
}



export function trackOperations(to, from) {
    dataLayer.push({
        'event': 'serp_tab_click',
        'serp_from': map[from],
        'serp_to': map[to]
    });
}
